import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=188cbfaf&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=188cbfaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cbfaf",
  null
  
)

export default component.exports